import { render } from "./fotograf-anette-hovland-logo-payload.svg?vue&type=template&id=c4131eda"
const script = {}
script.render = render

export default script